import { Component, OnInit } from '@angular/core';
import { DatabaseService } from '../providers/database.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ListComponent implements OnInit {
  streamList: any;
  selStream = {name: 'not yet'};

  constructor(public databaseService: DatabaseService) {
    var ref = databaseService.getStreams();
    ref.on('value',
      snap => {
        var streamsObject = snap.val();
        this.streamList = Object.keys(streamsObject).map(
          key => {
            return streamsObject[key];
          }
        )
      });
  }

  ngOnInit() {
  }

  startPlay(obj: any) {
    this.selStream = obj;
  }

  getHost(obj: any) {
    var parser = document.createElement('a');
    parser.href = obj.url;  
    return parser.host;
  }

  getPath(obj: any) {
    var parser = document.createElement('a');
    parser.href = obj.url;
    return parser.pathname;
  }
}



// WEBPACK FOOTER //
// /var/www/html/mediate/src/app/list/list.component.ts